import React from 'react';
import '../Stylesheets/index.css';

function Header() {
    return (
        <div id="ApplicationHeader" />
    );
}

export default Header;
